module.exports = __webpack_public_path__ + "static/media/sidebar-2.06009475.jpg";